import { useLocalStorageState } from 'ahooks'

import { sa } from '../helpers/sa'

import type { PurchaseSchemaInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCoreProps } from '.'
import type { IEcommerce, TrackCustomEventProps } from '..'
import type { ICoreItem } from './type'

export const useTrackPurchase = ({
  eventTracking,
}: ITrackCoreProps): ICoreItem<PurchaseSchemaInput> => {
  const [purchaseIdsLocalStorage, setPurchaseIds] = useLocalStorageState<
    string[]
  >('purchase-ids', {
    defaultValue: [],
    listenStorageChange: true,
  })

  const trackEvent = async (
    props: PurchaseSchemaInput & TrackCustomEventProps,
  ) => {
    const purchaseIds = purchaseIdsLocalStorage || []

    const { name, meta, commonParamsLatest } = props
    const params = [{ name, meta, ...commonParamsLatest.commonParams }]

    const ecommerce = meta as IEcommerce

    const { gaCommonParams, commonParams } = commonParamsLatest

    const onTrack = async () => {
      sa.track(name, {
        ecommerce,
        ...gaCommonParams,
      })
      await eventTracking(params)
    }

    if (
      ecommerce?.transaction_id &&
      !purchaseIds.includes(ecommerce.transaction_id) &&
      commonParams.commCountry !== 'unknown'
    ) {
      setPurchaseIds([...purchaseIds, ecommerce.transaction_id])
      await onTrack()
    } else if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') {
      await onTrack()
    }
  }

  return {
    trackEvent,
  }
}
